//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { InstagramHashtagsActions } from '@instagram-account/redux/hashtags/instagramHashtagsActions';
import {
    IInstagramHashtagsState,
    INSTAGRAM_HASHTAGS_ACTIONS,
} from '@instagram-account/redux/hashtags/instagramHashtagsModel';

const initialState: IInstagramHashtagsState = {
  isFetchingTrackedHashtags: false,
  isFetchingHashtagConfigs: false,
  trackedHashtags: [],
  hashtagConfigs: [],
};

export default function InstagramHashtagsReducer(
  state: IInstagramHashtagsState = initialState,
  action: InstagramHashtagsActions
): IInstagramHashtagsState {
  switch (action.type) {
    case INSTAGRAM_HASHTAGS_ACTIONS.REQUEST_INSTAGRAM_HASHTAGS:
      return {
        ...state,
        isFetchingTrackedHashtags: true,
      };
    case INSTAGRAM_HASHTAGS_ACTIONS.RECEIVE_INSTAGRAM_HASHTAGS_SUCCEEDED:
      return {
        ...state,
        isFetchingTrackedHashtags: false,
        trackedHashtags: action.trackedHashtags,
      };
    case INSTAGRAM_HASHTAGS_ACTIONS.RECEIVE_INSTAGRAM_HASHTAGS_FAILED:
      return {
        ...state,
        isFetchingTrackedHashtags: false,
      };
    case INSTAGRAM_HASHTAGS_ACTIONS.REQUEST_HASHTAGS_CONFIGS:
      return {
        ...state,
        isFetchingHashtagConfigs: true,
      };
    case INSTAGRAM_HASHTAGS_ACTIONS.RECEIVE_HASHTAGS_CONFIGS_SUCCEEDED:
      return {
        ...state,
        isFetchingHashtagConfigs: false,
        hashtagConfigs: action.hashtagConfigs,
      };
    case INSTAGRAM_HASHTAGS_ACTIONS.RECEIVE_HASHTAGS_CONFIGS_FAILED:
      return {
        ...state,
        isFetchingHashtagConfigs: false,
      };
    default:
      return state;
  }
}
